import React from 'react';

export default ({ children, titoloSezione }) => (
    
    <div className="it-list-wrapper list-attachment-icon">
        <h3 className="h6">{titoloSezione}</h3>
        <ul className="it-list">
            {children}
        </ul>
    </div>
    
);



